var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.html
    ? _c(
        _vm.tag,
        {
          tag: "component",
          style: { fontWeight: _vm.bold ? "bold" : undefined },
        },
        [
          _vm.before ? [_vm._v("…")] : _vm._e(),
          _vm._l(
            _vm.renderInfo,
            function ({ text, punct, style, title, relationKeys }, i) {
              return [
                style
                  ? _c("span", {
                      key: text + "_" + title + "_" + i,
                      class: {
                        hoverable: true,
                        hover: relationKeys?.some((c) =>
                          _vm.hoverMatchInfos.includes(c)
                        ),
                      },
                      style: style,
                      attrs: { title: title },
                      domProps: { innerHTML: _vm._s(text) },
                      on: {
                        mouseover: function ($event) {
                          return _vm.$emit("hover", relationKeys)
                        },
                        mouseout: function ($event) {
                          return _vm.$emit("unhover", relationKeys)
                        },
                      },
                    })
                  : _c("span", {
                      key: "text" + "_" + text + "_" + i,
                      domProps: { innerHTML: _vm._s(text) },
                    }),
                _c("span", {
                  key: "punct_" + punct + "_" + i,
                  domProps: { innerHTML: _vm._s(_vm.doPunct ? punct : " ") },
                }),
              ]
            }
          ),
          _vm.after ? [_vm._v("…")] : _vm._e(),
        ],
        2
      )
    : _c(
        _vm.tag,
        {
          tag: "component",
          style: { fontWeight: _vm.bold ? "bold" : undefined },
        },
        [
          _vm.before ? [_vm._v("…")] : _vm._e(),
          _vm._l(
            _vm.renderInfo,
            function ({ text, punct, style, title, relationKeys }, i) {
              return [
                style
                  ? _c(
                      "span",
                      {
                        key: text + "_" + title + "_" + i,
                        class: {
                          hoverable: true,
                          hover: relationKeys?.some((c) =>
                            _vm.hoverMatchInfos.includes(c)
                          ),
                        },
                        style: style,
                        attrs: { title: title },
                        on: {
                          mouseover: function ($event) {
                            return _vm.$emit("hover", relationKeys)
                          },
                          mouseout: function ($event) {
                            return _vm.$emit("unhover", relationKeys)
                          },
                        },
                      },
                      [_vm._v(_vm._s(text))]
                    )
                  : [_vm._v(_vm._s(text))],
                [_vm._v(_vm._s(_vm.doPunct ? punct : " "))],
              ]
            }
          ),
          _vm.after ? [_vm._v("…")] : _vm._e(),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }